import React, { useMemo, useRef } from "react";
import { useCustomAppActivityTracker } from "src/hooks/useCustomAppActivityTracker";
import { useCustomAppIdentity } from "src/hooks/useCustomAppIdentity";

// Dev only: with localStorage "csTrackerProxy" set (e.g. "http://localhost:4100"), apps load through
// dev-tools/iframe-tracker/proxy.js, which adds the in-app tracker script to every app.
function getFrameUrl(url) {
  const proxy = process.env.NODE_ENV === "development" && url && localStorage.getItem("csTrackerProxy");
  if (!proxy) return url;
  try {
    const app = new URL(url);
    const via = new URL(proxy);
    return `${via.protocol}//${app.hostname.split(".")[0]}.${via.host}${app.pathname}${app.search}`;
  } catch (error) {
    return url;
  }
}

export default function CustomAppEmbed({ content }) {
  const iframeRef = useRef(null);
  const frameUrl = useMemo(() => getFrameUrl(content?.custom_app_url), [content?.custom_app_url]);

  // Logs the user's activity in the iframe to the console
  useCustomAppActivityTracker({ content, iframeRef });
  // Signs the user in to apps that ask who is using them
  useCustomAppIdentity({ content, iframeRef, frameUrl });

  if (!content?.custom_app_url) {
    return <div className="p-6 text-center text-gray-500">Custom app URL is not available.</div>;
  }

  return (
    <div className="relative h-full min-h-0 w-full flex-1 overflow-hidden">
      <iframe
        ref={iframeRef}
        key={frameUrl}
        title={content.page_name || "Custom App"}
        src={frameUrl}
        className="block h-full w-full border-0"
        allowFullScreen
      />
    </div>
  );
}
